import * as _ from "lodash";
import { action, observable, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { ProjectPermission } from "./models/project-permission";

export class ProjectPermissionStore{
	@observable loading = false;
	@observable errorMessage: string = null;
	@observable projectPermissions: ProjectPermission[] = [];

	@action async loadProjectPermissions(projectMemberId: string, loadActions = true){
		try{
			this.loading = true;
			let result = await Agent.ProjectMembers.getProjectPermissions(projectMemberId);
			runInAction(() => {
				_.remove(this.projectPermissions, {"projectMemberId": projectMemberId});
				let pms = result.map((p) => new ProjectPermission(p));
				pms.forEach(pm => {
					this.projectPermissions.push(pm);
				});
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}

	findByMemberId(pmId: string){
		return _.filter(this.projectPermissions, {"projectMemberId": pmId});
	}
}



// WEBPACK FOOTER //
// ./src/stores/project-permission-store.ts